import axios from "axios";

const API_URL =
  (window._env_ && window._env_.REACT_APP_API_URL)
    ? window._env_.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL;
console.log("→ API_URL =", API_URL);

const PATH = API_URL;
const LOCAL_STORAGE_KEYS = ["user", "brandId", "orgLevel"];

const clearSessionAndRedirect = () => {
  LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);

const api = {
  get: async (url, data, token) => {
    const URL = PATH + url;

    try {
      const response = await axios.get(URL, {
        params: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      return {
        data: response,
        errorMessage: "",
        status: response.status
      };
    } catch (error) {
      return {
        data: null,
        errorMessage: error.response?.data || error.message || "Service Unavailable!",
        status: error.response?.status || 0
      };
    }
  },

  post: async (api, data, token) => {
    const URL = PATH + api;

    try {
      const response = await axios.post(URL, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      return {
        data: response,
        errorMessage: "",
        status: response.status
      };
    } catch (error) {
      return {
        data: null,
        errorMessage: error.response?.data || error.message || "Service Unavailable!",
        status: error.response?.status || 0
      };
    }
  },

  details: async (api, id, token) => {
    const URL = PATH + api + "/" + id;

    try {
      const response = await axios.get(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      return {
        data: response,
        errorMessage: "",
        status: response.status
      };
    } catch (error) {
      return {
        data: null,
        errorMessage: error.response?.data || error.message || "Service Unavailable!",
        status: error.response?.status || 0
      };
    }
  },

  delete: async (api, token) => {
    const URL = API_URL + api;

    try {
      const response = await axios.delete(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      return {
        data: response,
        errorMessage: "",
        status: response.status
      };
    } catch (error) {
      return {
        data: null,
        errorMessage: error.response?.data || error.message || "Delete Unsuccessful!",
        status: error.response?.status || 0
      };
    }
  },
};

export default api;
